import Core from "../core/editor/index";
import {withDefaultIcons} from "../defaults/with-default-icons";
import toolbar from "../defaults/toolbar";
import dialog from "../defaults/dialog";
import ai from "../defaults/ai";
import selection from "../defaults/selection";
import brands from "../defaults/brands";
export * from "../core/editor/index";
const Compatible = withDefaultIcons(Core, { ...toolbar, ...dialog, ...ai, ...selection }, brands);
export default Compatible;
